export default __webpack_public_path__ + "static/media/08AW1AUG66.d5fa1ed6.jpg";